import { render, staticRenderFns } from "./selectsheet_sin_login.vue?vue&type=template&id=1385ef4b&scoped=true&"
import script from "./selectsheet_sin_login.vue?vue&type=script&lang=ts&"
export * from "./selectsheet_sin_login.vue?vue&type=script&lang=ts&"
import style0 from "./selectsheet_sin_login.vue?vue&type=style&index=0&id=1385ef4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1385ef4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VHover,VRow})
